export const isTestFile = (fileInfo) => {
    if ("isTestFile" in fileInfo){
        return fileInfo.isTestFile
    }

    return false
}